import Logo2020Trade from '../src/Logo2020Trade';
export default Logo2020Trade;
